import { Form } from "antd"
import { Alert, Checkbox, Group, Legend, RadioButtons, SelectInput, TextInput } from "components/common"
import { IconText } from "components/custom"
import { ratingArray } from "constants/list"
import VoiceComment from "features/tasks/components/voiceComment/voiceComment"
import { t } from "i18next"
import { useSelector } from "react-redux"
import getPrivilege from "utils/privileges/privileges"
import theme from "utils/themeVars"

let recorderControls = null
const getController = controller => {
  recorderControls = controller
}

const LeadReviewForm = ({ form, rules, clientLeads, data, isFetching, lead }) => {
  const userPrivileges = useSelector(state => state.app.privileges)

  return (
    <Group gap="16px">
      {!lead && (
        <Form.Item name={"leadId"} label={t("Lead Id")} rules={rules} required>
          <SelectInput
            placeholder={t("Select Lead Id")}
            options={clientLeads}
            onChange={(_value, option) => {
              form.setFieldsValue({ leadId: option?.value })
            }}
          />
        </Form.Item>
      )}
      <Legend title={t("Progression")} />
      <Form.Item name="callRecording" label={t("Call Recording")} rules={rules} required>
        <RadioButtons options={ratingArray()} />
      </Form.Item>
      <Form.Item
        name="additionalComment"
        label={t("Additional Comment")}
        extra={
          <IconText
            icon="MdInfoOutline"
            iconProps={{ color: theme["gray800"], size: "1em" }}
            textType="secondary"
            title={t("Maximum 30 characters")}
          />
        }
      >
        <TextInput
          placeholder={t("Enter additional comment")}
          maxLength={30}
          lineCount={1}
          style={{ resize: "none" }}
        />
      </Form.Item>
      <Form.Item name="progressOnTask" label={t("Progress On Task")} rules={rules} required>
        <RadioButtons options={ratingArray()} />
      </Form.Item>
      <Form.Item
        name="additionalComment2"
        label={t("Additional Comment")}
        extra={
          <IconText
            icon="MdInfoOutline"
            iconProps={{ color: theme["gray800"], size: "1em" }}
            textType="secondary"
            title={t("Maximum 30 characters")}
          />
        }
      >
        <TextInput
          placeholder={t("Enter additional comment")}
          maxLength={30}
          lineCount={1}
          style={{ resize: "none" }}
        />
      </Form.Item>
      <Group template="repeat(2, 1fr)" gap="6px 32px">
        <Form.Item name={"proposedNextTask"} label={t("Proposed Next Task")} rules={rules} required>
          <SelectInput
            placeholder={t("Select")}
            options={data}
            loading={isFetching}
            onChange={(_value, option) => {
              form.setFieldsValue({ proposedNextTask: option })
            }}
          />
        </Form.Item>
        <Form.Item
          name="voiceComment"
          label={t("Add Voice Comment")}
          rules={[
            {
              validator: (_, _value) => {
                return recorderControls?.isRecording
                  ? Promise.reject(t("Recording is still in progress, press the save button"))
                  : Promise.resolve()
              },
            },
          ]}
        >
          <VoiceComment
            getController={getController}
            setVoice={voice => {
              form.setFieldsValue({ voiceComment: voice })
            }}
          />
        </Form.Item>
      </Group>
      <Legend title={t("Overall Feedback")} />
      <Form.Item
        name="feedback"
        label={t("Feedback")}
        rules={rules}
        required
        extra={
          <IconText
            icon="MdInfoOutline"
            iconProps={{ color: theme["gray800"], size: "1em" }}
            textType="secondary"
            title={t("Maximum 500 characters")}
          />
        }
      >
        <TextInput placeholder={t("Enter feedback")} maxLength={500} lineCount={4} style={{ resize: "none" }} />
      </Form.Item>
    </Group>
  )
}
export default LeadReviewForm
